import Yup from 'utils/validation';
import { Channels } from 'generated-graphql/types';

export const sourcingSharedChooseChannelSchema = Yup.object({
  channel: Yup.string().oneOf(Object.values(Channels)).required()
});

export type SourcingSharedChooseChannelFormData = Yup.InferType<
  typeof sourcingSharedChooseChannelSchema
>;
